export { default as PortalAccessForbidden } from './hocs';
